import { EventName } from '@lit/react';
import { BlocksTabs } from 'blocks-nextjs/blocks-web-components/components/tabs/tabs';
import { BlocksTabChange } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTabs = createComponent({
  react: React,
  tagName: 'cat-tabs',
  elementClass: BlocksTabs,
  events: {
    onBlTabChange: 'bl-tab-change' as EventName<BlocksTabChange>
  }
});
